// extracted by mini-css-extract-plugin
export default {"container":"JoinTeam_container__fdBnU","centered":"JoinTeam_centered__mBgTp"};